import {load} from '@shopify/theme-sections';
import 'preact/devtools';

// TEMPLATES
import './templates/collection.js';
import './templates/product.js';
import './templates/search.js';
import './templates/404.js';

// SECTIONS
import './sections/featured-collections.js';
import './sections/featured-reviews.js';
import './sections/header.js';
import './sections/hero-slider.js';
import './sections/image-text-cta.js';
import './sections/recommended-collection.js';
import './sections/shop-by-category.js';
import './sections/trending-categories.js';
import './sections/trust.js';


// COMPONENTS
import initProductCards from './components/product-card';

// REACT APPS
import '../app';

document.addEventListener('DOMContentLoaded', () => {
  load('*');
  initProductCards();
});
